import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, NgModuleRef } from '@angular/core';

// tslint:disable no-import-side-effect
import "primeng/resources/primeng.css";
// import "primeng/resources/themes/omega/theme.css?global";

if (process.env.PRODUCTION) {
    enableProdMode();
}

import { AppModule } from './app.module';

platformBrowserDynamic().bootstrapModule(AppModule, {preserveWhitespaces: true})
    // tslint:disable-next-line:no-console
    .then((r: NgModuleRef<AppModule>): void => console.info("Afidium app launched !"))
    .catch((reason: any) => console.error("Afidium app crashed at launch --> ", reason));
